import PusherMessagingService from './PusherMessagingService';

const messagingService = new PusherMessagingService();

export default messagingService;
